"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AWSS3Provider_1 = require("./AWSS3Provider");
exports.AWSS3Provider = AWSS3Provider_1.default;
//# sourceMappingURL=index.js.map